// extracted by mini-css-extract-plugin
export default {"createContactHolder":"Contacts_createContactHolder__sP3Ym","btnHolder":"Contacts_btnHolder__A6XD4"};